export default {
  type: 'Sum',
  label: `Sum Field`,
  mask: '2',
  // TODO: DOUBLE CHECK THIS MASK VALUE
  style: 0
};